var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.61229 7.14748C4.711 7.14691 4.80884 7.16582 4.90022 7.20315C4.9916 7.24047 5.07471 7.29547 5.14479 7.36498L9.08229 11.31L13.0273 7.36498C13.1678 7.22529 13.3579 7.14688 13.556 7.14688C13.7542 7.14688 13.9443 7.22529 14.0848 7.36498C14.1551 7.4347 14.2109 7.51765 14.249 7.60904C14.287 7.70044 14.3066 7.79847 14.3066 7.89748C14.3066 7.99649 14.287 8.09452 14.249 8.18591C14.2109 8.2773 14.1551 8.36025 14.0848 8.42998L9.58479 12.93C9.44427 13.0697 9.25418 13.1481 9.05604 13.1481C8.8579 13.1481 8.66781 13.0697 8.52729 12.93L4.02729 8.42998C3.957 8.36025 3.9012 8.2773 3.86312 8.18591C3.82505 8.09451 3.80544 7.99648 3.80544 7.89748C3.80544 7.79847 3.82505 7.70044 3.86312 7.60904C3.9012 7.51765 3.957 7.4347 4.02729 7.36498C4.10347 7.28885 4.19515 7.23002 4.29609 7.19248C4.39704 7.15495 4.50488 7.1396 4.61229 7.14748Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.f54c8f280fa58422f11a194faeca57e3.svg";
export { ForwardRef as ReactComponent };